import * as React from "react";
import styles from "./Skeleton.module.css";
import { cn } from "../../../utils/cn";

const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-slot="skeleton"
      className={cn(styles.skeleton, className)}
      {...props}
    />
  );
};

export { Skeleton };
